import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { Bodega } from '../../model/bodega';
import { ReporteRecepcionesDiarias } from '../../model/reporte-recepciones-diarias';

import { BodegaService } from '../../services/bodega.service';
import { SucursalService } from '../../services/sucursal.service';
import { ReporteInventarioService } from '../../services/reporte-inventario.service';

@Component({
  selector: 'app-reporte-recepciones-diarias',
  templateUrl: './reporte-recepciones-diarias.component.html',
  styleUrls: ['./reporte-recepciones-diarias.component.css']
})

export class ReporteRecepcionesDiariasComponent implements OnInit {

  public fechaActual: Date;
  public filtro: boolean;
  public usuario: string;
  public _filtro: string;
  public buscando: boolean;

  public documentosSeleccionadosVisual: string;
  public editMode: boolean;
  public recepciones: ReporteRecepcionesDiarias[];
  public criterio: any;
  public query: any;
  public bodega: Bodega;
  public bodegas: Bodega[];
  public recepcion: string;

  constructor(
    private _bodegaService: BodegaService,
    private _sucursalService: SucursalService,
    private _inventario: ReporteInventarioService
  ) { }

  ngOnInit() {
    this.bodega = new Bodega();
    this.bodegas = [];
    this.recepcion = "";
    this._filtro = "";
    this.recepciones = [];
    this.editMode = false;
    this.buscando = false;
    this.usuario = sessionStorage.getItem("login");
    this.query = "";
    this.fechaActual = new Date();
    this.filtro = true;

    this.cargarBodegas();
  }

  filtroToggle() {
    this.filtro = !this.filtro;
  }

  Disabled_Button() {
    return (this.bodega.codigoBodega === null || this.recepcion === "");
  }

  cargarBodegas() {
    this._bodegaService.getBodegas()
      .subscribe(
      data => {
        this.bodegas = data;
      },
      err => {
        console.log(err._body);
      });

  }


  realizarConsulta() {
    if (this.bodega === null || this.recepcion === "") {
      return;
    }
    this.buscando = true;
    this.query = ("Bodega:" + this.bodega.codigoBodega + "|Recepcion:" + this.recepcion).toString();
    this._inventario.getRecepcionesDiarias({ "ETIQUETA": "RECEPCIONESDIARIASSUPREME", "QUERY": this.query })
      .subscribe(
      data => {
        this.buscando = false;
        this.recepciones = data;
      },
      err => {
        this.buscando = false;
        console.log(err._body);
      });

    this.filtro = false;
  }

  toggleEdit() {
    this.editMode = !this.editMode;
  }

  exportar() {

    this.editMode = false;

    var ar = this.recepciones;

    //comprobamos compatibilidad
    if (window.Blob && (window.URL)) {
      var contenido = "", d = new Date(), blob, _reader, save, clicEvent;
      //creamos contenido del archivo
      for (var i = 0; i < ar.length; i++) {
        //construimos cabecera del csv
        if (i == 0)
          contenido += Object.keys(ar[i]).join(";") + "\n";
        //resto del contenido
        contenido += Object.keys(ar[i]).map(function (key) {
          return ar[i][key];
        }).join(";") + "\n";
      }
      //creamos el blob
      blob = new Blob(["\ufeff", contenido], { type: 'text/csv' });
      //creamos el reader
      _reader = new FileReader();
      _reader.onload = function (event) {
        //escuchamos su evento load y creamos un enlace en dom
        save = document.createElement('a');
        save.href = event.target.result;
        save.target = '_blank';
        //aquí le damos nombre al archivo
        save.download = "ReporteRecepcionesDiarias" + d.getDate() + "_" + (d.getMonth() + 1) + "_" + d.getFullYear() + ".csv";
        try {
          //creamos un evento click
          clicEvent = new MouseEvent('click', {
            'view': window,
            'bubbles': true,
            'cancelable': true
          });
        } catch (e) {
          //si llega aquí es que probablemente implemente la forma antigua de crear un enlace
          clicEvent = document.createEvent("MouseEvent");
          clicEvent.initEvent('click', true, true);
        }
        //disparamos el evento
        save.dispatchEvent(clicEvent);
        //liberamos el objeto window.URL
        (window.URL).revokeObjectURL(save.href);
      }
      //leemos como url
      _reader.readAsDataURL(blob);
    } else {
      //el navegador no admite esta opción
      alert("Su navegador no permite esta acción");
    }
  }

  imprimir() {

    this.editMode = false;

    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
          //........Customized style.......
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }


}




// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/reporte-recepciones-diarias/reporte-recepciones-diarias.component.ts